import React, { useState, ChangeEvent, FormEvent } from "react";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import Button from "../form-components/input/Button";


const UploadRulingJudgementRecordsDocument = () => {
    const [documentFiles, setDocumentFiles] = useState<File[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { applicationsId } = useParams<{ applicationsId: string }>();
    const applicationId = applicationsId;
    const { id } = useParams<{ id: string }>();
    const caseId = id;
    const { applicationsType } = useParams<{ applicationsType: string }>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const applicationType = applicationsType;
    const authToken = sessionStorage.getItem('token');
    const approved = true;
    const navigate = useNavigate();

    const handleDocumentUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(event.target.files || []);
        setDocumentFiles(files);
    };

    const getUploadUrl = async (contentType: string) => {
        if (!caseId) {
            console.log("case ID is required.");
            return;
        }
        if (!applicationId) {
            console.log("Application ID is required.");
            return;
        }

        const response = await fetch(
            "https://backend-kyw8.onrender.com/court-records/documents/upload-url",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({ caseId, applicationId, contentType, uploadType: 'approval_doc' }),
            }
        );

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error ?? "An error occurred");
        }

        return data;
    };

    const uploadToS3 = async (URL: string, file: Blob, contentType: string) => {
        const response = await fetch(URL, {
            method: "PUT",
            headers: {
                "Content-Type": contentType,
            },
            body: file,
        });

        if (!response.ok) {
            throw new Error("An error occurred while uploading the file(s)");
        }
    };

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();

        if (documentFiles.length === 0) {
            console.log("At least one document file is required.");
            return;
        }

        try {
            setIsLoading(true);
            const approvalDocumentURLs: string[] = []; // Array to hold the file URLs

            // Upload each document file
            for (const documentFile of documentFiles) {
                const documentUploadData = await getUploadUrl(documentFile.type);
                const documentFileURL = documentUploadData?.fileURL;

                if (documentUploadData?.uploadURL && documentFileURL) {
                    await uploadToS3(documentUploadData.uploadURL, documentFile, documentFile.type);
                    console.log("Document uploaded successfully.");

                    // Push the document URL to the array
                    approvalDocumentURLs.push(documentFileURL);
                    console.log(approvalDocumentURLs);
                } else {
                    throw new Error("Document upload URL or file URL not provided by the server.");
                }
            }

            // Send the array of file URLs to the backend
            const saveResponse = await fetch("https://backend-kyw8.onrender.com/court-records", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                    applicationId,
                    approvalDocument: approvalDocumentURLs, // Send the array of URLs
                    approved
                })
            });

            if (!saveResponse.ok) {
                throw new Error("Failed to save file URLs to the backend.");
            }

            setIsLoading(false);
            console.log("Documents were successfully uploaded");
            toast.success("Documents were successfully uploaded", {
                position: "top-center",
            });
            navigate('/')
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("An unexpected error occurred. Please try again later.", {
                position: "bottom-right",
            });
            setIsLoading(false);
        }
    };

    return (
        <div className="">
            <div className="max-w-lg mb-40 mx-auto md:mt-20 lg:mt-20 bg-white rounded-xl flex flex-col gap-6 p-8 bg-white shadow-lg border border-[#222222] rounded-2xl">
                <h3 className="text-2xl font-semibold text-[#222222] border-b pb-3 mb-6">Upload Documents</h3>
                <form onSubmit={handleSubmit} className="flex flex-col gap-8">
                    <div className="flex flex-col gap-4">
                    <label htmlFor="seal" className="text-lg font-medium text-gray-700">
                        Upload Approval Documents:
                    </label>
                    <input
                        type="file"
                        onChange={handleDocumentUpload}
                        multiple
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-[#E5D4C0] file:text-[#222222] hover:file:bg-[#D5BBA0]"
                    />
                    </div>
                    <div className="flex justify-end">
                    <Button
                        buttonText="Submit"
                        onClick={handleSubmit}
                        isLoading={isLoading}
                        disabled={isLoading}
                        className="bg-[#222222] text-white px-6 py-2 rounded-full font-semibold hover:bg-[#5A3723] disabled:bg-gray-300 disabled:cursor-not-allowed transition duration-200 ease-in-out"
                    />
                    </div>
                </form>
                </div>
        </div>
    );
};

export default UploadRulingJudgementRecordsDocument;
